import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-result-template',
  templateUrl: './result-template.component.html',
  styleUrls: ['./result-template.component.css']
})
export class ResultTemplateComponent implements OnInit {

  @Input() reportData = [];
  @Input() level: number;
  @Input() graphWidth: string;
  @Input() filterFactor: any;

  subLevelVisibility = [];

  constructor() { }

  ngOnInit() {
  }

  getWidth () {
    return parseInt(this.graphWidth, 10) || 100;
  }

  getPercentBasedWidth(item, i) {
    return (item[`range${i}Perc`] / 100) * this.getWidth();
  }

  generateCountGraph(item) {
    let html = '<div class="ranges">';

    [1, 2, 3, 4].forEach(i => {
      var width = this.getCountBasedWidth(item, i),
        count = item[`range${i}Count`];

      if (count > 0) {
        html += `<div class="graphCell" style="width:${width}px" title="${count}"><div class="graphBar range${i}" style="width:${width}px">${count}</div></div>`;
      }
    });

    html += '</div>';

    return html;
  }

  getCountBasedWidth(item, i) {
    let itemCount = item['range' + i + 'Count'];
    let graphWidth = this.getWidth();

    let relativeSize = itemCount / item.maxRange;
    let computedSize = relativeSize * graphWidth;

    return computedSize;
  }

  generatePercentGraph (item) {
    let html = '<div class="ranges">';

    [1, 2, 3, 4].forEach(i => {
      const width = this.getPercentBasedWidth(item, i),
            percent = item['range' + i + 'Perc'];
      let label = percent.toFixed(2).replace('.', ',');

      if (label.toString().indexOf(',00') > -1) {
        label = label.replace(',00', '');
      }

      if (percent > 0) {
        html += `<div class="graphCell" title="${label}"><div class="graphBar range${i}" style="width:${width}px">${label}</div></div>`;
      }
    });

    html += '</div>';

    return html;
  }

  getSubLevelVisibility (item) {
    for (let i = 0; i < this.subLevelVisibility.length; i++) {
      if (this.subLevelVisibility[i].groupingLabel == item.groupingLabel) {
        return this.subLevelVisibility[i].isVisible;
      }
    }

    const visibilityItem = { groupingLabel: item.groupingLabel, isVisible: false };
    this.subLevelVisibility.push(visibilityItem);

    return false;
  }

  setSubLevelVisibility(item) {
    for (let i = 0; i < this.subLevelVisibility.length; i++) {
      if (this.subLevelVisibility[i].groupingLabel == item.groupingLabel) {
        this.subLevelVisibility[i].isVisible = !this.subLevelVisibility[i].isVisible;
        break;
      }
    }
  }

  adjustGroupingLabelExibition(label: string) {
    const length = 24;
    if (label.length > length) {
      label = label.substr(0, length) + '...';
    }
    return label;
  }

}
